import ResourceBalance from "./ResourceBalance";

export default ResourceBalance;